import { useState } from 'react';
import './CreateAdminModal.css'; // Reuse common modal styles

function KycDetailsModal({ isOpen, onClose, kycData }) {
    if (!isOpen || !kycData) return null;

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-content kyc-details-modal" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '900px', width: '90%' }}>
                <div className="modal-header">
                    <h2>🔍 KYC Verification Details - {kycData.name}</h2>
                    <button className="modal-close-btn" onClick={onClose}>×</button>
                </div>

                <div className="modal-body" style={{ padding: '24px', maxHeight: '80vh', overflowY: 'auto' }}>
                    <div className="kyc-details-grid" style={{ display: 'grid', gridTemplateColumns: '1fr 1.5fr', gap: '30px' }}>
                        {/* Left Side: Extracted Metadata */}
                        <div className="details-section">
                            <h3 style={{ borderBottom: '1px solid #eee', paddingBottom: '10px' }}>📄 Extracted Information (OCR)</h3>
                            <div className="info-cards" style={{ display: 'grid', gap: '15px', marginTop: '15px' }}>
                                <div className="info-item">
                                    <label style={{ display: 'block', fontSize: '12px', color: '#666' }}>FULL NAME</label>
                                    <strong style={{ fontSize: '16px' }}>{kycData.details?.name || kycData.name}</strong>
                                </div>
                                <div className="info-item">
                                    <label style={{ display: 'block', fontSize: '12px', color: '#666' }}>IDENTIFIER (EMAIL/PHONE)</label>
                                    <strong>{kycData.email || kycData.phone}</strong>
                                </div>
                                <div className="info-item">
                                    <label style={{ display: 'block', fontSize: '12px', color: '#666' }}>KYC STATUS</label>
                                    <span className={`status-badge ${kycData.kyc_status}`} style={{ margin: 0 }}>
                                        {kycData.kyc_status?.toUpperCase()}
                                    </span>
                                </div>
                                <div className="info-item">
                                    <label style={{ display: 'block', fontSize: '12px', color: '#666' }}>KID (DIGIO ID)</label>
                                    <code style={{ background: '#f0f0f0', padding: '4px 8px', borderRadius: '4px' }}>
                                        {kycData.digio_kid || 'N/A'}
                                    </code>
                                </div>
                                <div className="info-item">
                                    <label style={{ display: 'block', fontSize: '12px', color: '#666' }}>FACE MATCH SCORE</label>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                        <div style={{ flex: 1, height: '8px', background: '#eee', borderRadius: '4px' }}>
                                            <div style={{
                                                width: `${kycData.details?.face_match_obj?.match_score || 0}%`,
                                                height: '100%',
                                                background: (kycData.details?.face_match_obj?.match_score || 0) > 80 ? '#27ae60' : '#e67e22',
                                                borderRadius: '4px'
                                            }}></div>
                                        </div>
                                        <strong>{kycData.details?.face_match_obj?.match_score || 'N/A'}%</strong>
                                    </div>
                                </div>
                            </div>

                            <div className="admin-verdict" style={{ marginTop: '30px', padding: '15px', background: '#f8f9fa', borderRadius: '8px' }}>
                                <h4>Request Raw JSON</h4>
                                <pre style={{ fontSize: '10px', background: '#2d3436', color: '#ecf0f1', padding: '10px', borderRadius: '4px', overflowX: 'auto', marginTop: '10px' }}>
                                    {JSON.stringify(kycData.details || {}, null, 2)}
                                </pre>
                            </div>
                        </div>

                        {/* Right Side: Visual Assets */}
                        <div className="assets-section">
                            <h3 style={{ borderBottom: '1px solid #eee', paddingBottom: '10px' }}>📸 KYC Data Summary</h3>
                            <div className="summary-list" style={{ marginTop: '15px' }}>
                                {kycData.details?.actions?.map((action, idx) => (
                                    <div key={idx} style={{ marginBottom: '15px', padding: '10px', border: '1px solid #eee', borderRadius: '6px' }}>
                                        <strong>{action.type?.replace(/_/g, ' ')}</strong>
                                        <div style={{ fontSize: '13px', color: '#555', marginTop: '5px' }}>
                                            Status: <span style={{ color: action.status === 'completed' ? '#27ae60' : '#e67e22' }}>{action.status}</span>
                                        </div>
                                        {action.details && (
                                            <ul style={{ fontSize: '12px', marginTop: '5px', paddingLeft: '15px' }}>
                                                {Object.entries(action.details).slice(0, 5).map(([key, val]) => (
                                                    <li key={key}>{key}: {String(val)}</li>
                                                ))}
                                            </ul>
                                        )}
                                    </div>
                                ))}
                                {!kycData.details?.actions && (
                                    <p style={{ color: '#666', fontSize: '14px' }}>No detailed action breakdown available for this request.</p>
                                )}
                            </div>
                        </div>
                    </div>
                </div>

                <div className="modal-footer" style={{ borderTop: '1px solid #eee', padding: '15px 24px', textAlign: 'right' }}>
                    <button className="secondary-btn" onClick={onClose}>Close Window</button>
                </div>
            </div>
        </div>
    );
}

export default KycDetailsModal;
